module.exports = __webpack_public_path__ + "static/Pt02-7d44939835381824bd698c2814798885.jpg";